import "./../css/style.scss";
import $ from 'jquery';
/*global nsh_content*/
/*eslint no-undef: "error"*/
/*global dataLayer*/
/*eslint no-undef: "error"*/

// Hide Header on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('header').outerHeight();
let euVisible = false;
let scrollTop = 0;

$(document).on('gform_post_render', function () {

    $('.gfield_required.gfield_required_text').text('*');
    $('.gform_wrapper .ginput_container:not(.ginput_complex):not(.ginput_container_radio):not(.ginput_container_checkbox) input, .gform_wrapper .ginput_container:not(.ginput_complex):not(.ginput_container_radio):not(.ginput_container_checkbox) textarea').each(
        function () {
            if ($(this).val() != '') {
                $(this).closest(".gfield").addClass("focused");
                $(this).closest(".gfield").addClass("filled");
            } else {
                $(this).closest(".gfield").removeClass("focused");
                $(this).closest(".gfield").removeClass("filled");
            }
        }
    );

    $('.gform_wrapper .e-novice-form .gfield--type-email input').each(
        function () {
            if ($(this).val() != '') {
                $(this).closest(".gform_body").addClass("show-hidden-fields");
            }
        }
    );

});

$(document).on('gform_confirmation_loaded', function (event, formId) {
    dataLayer.push({'event': 'formSubmittedOW', 'formID': formId});
});

$(function () {
    hasScrolled();
    if (typeof dataLayer !== 'undefined' && Array.isArray(dataLayer)) {
        if (nsh_content) {
            dataLayer.push({
                'event': 'page_view',
                'nsh_content': nsh_content
            });
        }
    }

    if ($(window).width() < 989) {
        $(".menu-item-has-children>a, .menu-item-has-children>p").on("click", function (event) {
            event.preventDefault();
            $(this).siblings(".sub-menu").addClass("active");
        });
        $(".page-item-back").on("click", function (event) {
            event.preventDefault();
            $(this).parent().removeClass("active");
        });
        $(".projekti-home .mobile-dropdown").on("click", function (event) {
            event.preventDefault();
            $(this).toggleClass("active");
            $(this).parent().siblings(".menu").toggleClass("active");
        });
        scrollTop = $(window).scrollTop();
        euLogo(scrollTop);
    }

    if ($(".gform_wrapper").length) {
        $(document).on('focus', '.gform_wrapper .ginput_container:not(.ginput_complex):not(.ginput_container_radio):not(.ginput_container_checkbox) input, .gform_wrapper .ginput_container:not(.ginput_complex):not(.ginput_container_radio):not(.ginput_container_checkbox) textarea', function () {
            $(this).closest(".gfield").addClass("focused");
        });

        $(document).on('change keydown paste input', '.gform_wrapper .ginput_container:not(.ginput_complex):not(.ginput_container_radio):not(.ginput_container_checkbox) input,.gform_wrapper .ginput_container:not(.ginput_complex):not(.ginput_container_radio):not(.ginput_container_checkbox) textarea', function () {
            if ($(this).val() == '') {
                $(this).closest(".gfield").removeClass("filled");
            } else {
                $(this).closest(".gfield").addClass("filled");
            }
        });

        $(document).on('blur', '.gform_wrapper .ginput_container:not(.ginput_complex):not(.ginput_container_radio):not(.ginput_container_checkbox) input,.gform_wrapper .ginput_container:not(.ginput_complex):not(.ginput_container_radio):not(.ginput_container_checkbox) textarea', function () {
            if ($(this).val() == '') {
                $(this).closest(".gfield").removeClass("focused");
            }
        });

        $(document).on('focus', '.gform_wrapper .e-novice-form .gfield--type-email input', function () {
            $(this).closest(".gform_body").addClass("show-hidden-fields");
        });
        $(document).on('blur', '.gform_wrapper .e-novice-form .gfield--type-email input', function () {
            if ($(this).val() == '') {
                $(this).closest(".gform_body").removeClass("show-hidden-fields");
            }
        });
    }

    $(".zasciteni-proizvodi-shema__show-all").on("click", function () {
        $(this).hide()
        $(this).siblings(".zasciteni-proizvodi-shema__products").addClass("show-all");
    });

    $(document).on("click", ".zasciteni-proizvod-card, .zasciteni-proizvod-small-card", function () {
        const id = $(this).data('id');
        $.ajax({
            url: '/wp-json/optiweb/v1/zasciteni-proizvodi-html/' + id,
            method: 'GET',
            success: function (response) {
                $(".ow-popup").show();
                $(".ow-popup__inner").empty().append(response);
                setTimeout(function () {
                    $(".ow-popup").addClass("ow-popup--visible");
                }, 10);
            },
            error: function () {
                alert("error");
            }
        });
    });
    $(".ow-popup__close").on("click", function () {
        $(".ow-popup").removeClass("ow-popup--visible");
        setTimeout(function () {
            $(".ow-popup__inner").empty();
            $(".ow-popup").hide();
        }, 500);
    });

    $(".ow-popup").on("click", function (event) {
        if (event.target.className == 'ow-popup ow-popup--side ow-popup--visible') {
            $(".ow-popup").removeClass("ow-popup--visible");
            setTimeout(function () {
                $(".ow-popup__inner").empty();
                $(".ow-popup").hide();
            }, 500);
        }
    });

    $(".newsletter__primer-novicnika").on("click", function () {
        $.ajax({
            url: '/wp-json/optiweb/v1/primer-novicnika',
            method: 'GET',
            success: function (response) {
                $(".ow-popup").show();
                $(".ow-popup__inner").empty().append(response);
                setTimeout(function () {
                    $(".ow-popup").addClass("ow-popup--visible");
                }, 10);
            },
            error: function () {
                alert("error");
            }
        });
    });

    let showLabel = 'Prikaži';
    let hideLabel = 'Skrij';
    let showType = 'password';
    let hideType = 'text';

    $('input[type="password"]').each(function () {
        let $togglePassword = $(`<p class="toggle-password" style="display:none;">${showLabel}</p>`);
        $(this).after($togglePassword);
        $(this).css('position', 'relative');
        $(this).parent().css('position', 'relative');
        $(this).on('input', function () {
            $togglePassword.toggle($(this).val().length > 0);
        });
    });

    $(document).on('click', '.toggle-password', function () {
        let currentLabel = $(this).text();
        let newLabel = currentLabel === showLabel ? hideLabel : showLabel;
        let newType = currentLabel === showLabel ? hideType : showType;
        $(this).text(newLabel);
        $(this).prev().attr('type', newType);
    });
});


$(window).on('scroll', function () {
    didScroll = true;
    if ($(window).width() < 989) {
        scrollTop = $(window).scrollTop();
        euLogo(scrollTop);
    }
});

setInterval(function () {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 150);

function hasScrolled() {
    var st = $(window).scrollTop();

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) {
        return;
    }

    // Remove class on top
    if (st < 10) {
        $('header').removeClass('nav-down');
        $('header').removeClass('nav-up');
        return;
    }

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        $('header').removeClass('nav-down').addClass('nav-up');
    } else {
        // Scroll Up
        if (st + $(window).height() < $(document).height()) {
            $('header').removeClass('nav-up').addClass('nav-down');
        }
    }

    lastScrollTop = st;
}


//mobile footer start

function handleMenuToggle() {
    let footer = $('#footer');

    if (footer.length > 0) {
        let selectedColumns = $(".flex_column").slice(1, 4);

        if (window.matchMedia("only screen and (max-width: 767px)").matches) {
            selectedColumns.each(function () {
                let widgetTitle = $(this).find('.widgettitle');
                let menuContainer = $(this).find('.menu');

                // Hide only the menu-main-menu-container within selectedColumns
                menuContainer.hide();

                widgetTitle.off('click').on('click', function () {
                    $(this).next().children('.menu').slideToggle();
                    $(this).toggleClass('active');
                });
            });
        } else {
            $('.menu').show();
            selectedColumns.each(function () {
                let widgetTitle = $(this).find('.widgettitle');
                widgetTitle.off('click');
            });
        }
    }
}

function euLogo(scroll) {
    if ($(".gov-logo").length > 0) {
        if (scroll < 100) {
            if (!euVisible) {
                euVisible = true;
                $(".gov-logo").css("visibility", "visible");
                $(".gov-logo").animate({
                    opacity: 1,
                    bottom: '11px'
                }, 300);
            }
        } else {
            if (euVisible) {
                euVisible = false;

                $(".gov-logo").animate({
                    opacity: 0,
                    bottom: '-100px'
                }, 300, function () {
                    $(this).css("visibility", "hidden");
                });
            }
        }
    }
}

$(document).ready(function () {
    handleMenuToggle();

    $(window).resize(function () {
        handleMenuToggle();
    });
});


//mobile footer end
